import { Container, Row, Col, Form, InputGroup, Image} from 'react-bootstrap'
import Link from 'next/link';
import { Request } from '@group-devs/yfp7-global-modules'
import { FaFacebookF, FaPinterestP, FaTwitter } from 'react-icons/fa';
const request = new Request(process.env.apiDomain)

function ThanksForRequesting (props) {
    
    const url = process.env.backofficeDomain;

    const accountId = props.props.site.accountId;
    const currentUrl = 'https://' + props.props.site.url
    const { data: profile  } = request.account.swrAccountProfile(accountId)
    const user_id = profile ? parseInt(profile.user.id) : '';

return (
        <div>
            <div className="tvc__ThanksForRequesting pt-5">
                <Container>
                    <Row>
                        <Col lg={7} md={12} className="pt-5">
                        <div>
                            <h1 className="text-orange mb-5">THANKS FOR REQUESTING <br />MY FREE CHECKLIST!</h1>
                            <Form className="tvc__Form--download">
                                <InputGroup className="mb-2">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text>
                                            <Link href={url + "website/ebook/tvc?user_id="+user_id+"&download=true"}>
                                                <a className="">
                                                    <img className="img-fluid" src="../images/tvc/img-wyd-download01.png" alt="Download" />
                                                </a>
                                            </Link>
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control className="py-4 bg-orange text-white w-100" as="default" disabled>
                                        <Link href={url + "website/ebook/tvc?user_id="+user_id+"&download=true"}>
                                        <a className="text-white">
                                            <option>DOWNLOAD THE CHECKLIST</option>
                                        </a>
                                        </Link>
                                    </Form.Control>
                                </InputGroup>
                            </Form>
                            <Form className="tvc__Form--share">
                                <InputGroup className="mb-2">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text><img className="img-fluid" src="../images/tvc/img-wyd-share01.png" alt="Share" /></InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control className="py-4 bg-orange text-white w-100" as="default" disabled>
                                        <option>SHARE THIS</option>
                                    </Form.Control>
                                </InputGroup>
                            </Form>
                            <Form className="tvc__Form--links">
                                <InputGroup className="">
                                    <Form.Control className="tvc__Form--icons px-4 pt-3" as="default" disabled>
                                        <div className="">
                                            <Link href={"https://www.facebook.com/sharer/sharer.php?u=" + currentUrl}>
                                                <a target="_blank" className="ml-3 mr-4"><FaFacebookF className="position-relative text-dark" /></a></Link>
                                            <Link href={"https://twitter.com/intent/tweet?url=" + currentUrl + "&text=The%20Vitamin%20Checklist"}>
                                                <a target="_blank" className="mr-4"><FaTwitter className="position-relative text-dark" /></a></Link>
                                            <Link href={"http://pinterest.com/pin/create/button/?url=" + currentUrl + "&media=&description=The%20Vitamin%20Checklist"}>
                                                <a target="_blank" className=""><FaPinterestP className="position-relative text-dark" /></a></Link>
                                        </div>
                                    </Form.Control>
                                </InputGroup>
                            </Form>
                        </div>
                        </Col>
                        <Col lg={5} md={12} className="pt-5">
                        <img className="tvc__workBook-img img-fluid" src="../images/tvc/img-download-free-ebook01.png" alt="Ebook" />
                        </Col>
                    </Row>
                </Container>
            </div>
            <style jsx global>{`
                .input-group-text{
                    background:#ffe090; 
                }
                .tvc__Form--download .form-control{
                    max-width: 350px;
                }
                .tvc__Form--share .form-control{
                    max-width: 192px;
                }
                .tvc__Form--links .form-control{
                    margin-top: -10px;
                    max-width: 245px;
                    background: #e5e5e5;
                    height: 55px!important;
                }
                .tvc__Form--links .form-control a{
                    border: 2px solid #333;
                    border-radius: 50%;
                    padding:3px 10px;
                }
                    @media(max-width:436px){
                        .tvc__Form--download .form-control{
                        max-width:300px;
                        }
                    }
                    @media(max-width:386px){
                        .tvc__Form--download .form-control{
                        max-width:260px;
                        }
                    }
                    @media(max-width:346px){
                        .tvc__Form--download .form-control{
                            max-width: 233px;
                        }
                    }
                `}
            </style>
            <style jsx>{`
                .tvc__ThanksForRequesting{
                    background: #efefef url(../images/tvc/img-bg-hero01.jpg);
                    padding-bottom: 150px;
                }
                h1{
                    font-family: 'Oswald', sans-serif;
                    font-size:3rem;
                }
                option{
                    font-size: 1.2rem;
                    font-weight: 500;
                    margin-top: -15px;
                }
                .tvc__workBook-img {
                    max-width: 70%;
                }
                @media(max-width:991px){
                    .tvc__workBook-img{
                        display: block;
                        margin:3rem auto;
                    }
                    h1{
                        text-align:center;
                        font-size: 2.5rem;
                    }
                    option{
                        font-size: 1rem;
                    }
                }
                @media(max-width:346px){
                    h1{
                        font-size: 2rem;
                    }
                    option{
                        font-size: 0.9rem;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default ThanksForRequesting;